<template>
  <div class="logcomment">
    <div class="comments">
      <div
        class="ed"
        v-if="
          commentdata.receive_employees && commentdata.receive_employees.length
        "
      >
        <div>接收人</div>
        <div class="employees">
          <div
            class="items"
            v-for="item in commentdata.receive_employees"
            :key="item.id"
          >
            <img
              class="isRead"
              v-if="item.is_read == 1"
              src="@/assets/img/isRead.png"
              alt=""
            />
            <img
              class="picture"
              v-if="item.picture"
              :src="item.picture"
              alt=""
            />
            <div v-else class="tan">
              {{ item.name ? item.name.slice(-1) : "" }}
            </div>
            <div>
              {{ item.name }}
              <!-- <span v-if="item.is_read == 1" class="is_read">(已读)</span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="sl">评论 （{{ commentdata.comments.length }}）</div>
      <div v-for="(item, index) in commentdata.comments" :key="index">
        <div class="lflex jus">
          <div class="lflex" v-if="!item.reply_employee.id">
            <img
              class="img"
              v-if="item.employee.picture"
              :src="item.employee.picture"
              alt=""
            />
            <div v-else class="tan">
              {{ item.employee.name ? item.employee.name.slice(-1) : "" }}
            </div>
            <div class="lflex1">
              <div>
                {{ item.employee.name }}
                <span class="time">{{ item.create_time }}</span>
              </div>
              <div class="lt" v-if="userid != item.employee_id">
                <el-button
                  :size="subUnitSize"
                  @click="setreplycomment(item)"
                  v-show="i === index"
                  >取消回复</el-button
                >
                <el-button
                  :size="subUnitSize"
                  @click="setindex(index, item)"
                  v-show="i !== index"
                  >回复</el-button
                >
              </div>
            </div>
          </div>
          <div class="lflex" v-else>
            <img
              class="img"
              v-if="item.employee.picture"
              :src="item.employee.picture"
              alt=""
            />
            <div v-else class="tan">
              {{ item.employee.name ? item.employee.name.slice(-1) : "" }}
            </div>
            <div class="lflex1">
              <div>
                {{ item.employee.name }} 回复 {{ item.reply_employee.name }}
                <span class="time">{{ item.create_time }}</span>
              </div>

              <div class="lt" v-if="userid != item.employee_id">
                <el-button
                  :size="subUnitSize"
                  @click="setreplycomment(item)"
                  v-show="i === index"
                  >取消回复</el-button
                >
                <el-button
                  :size="subUnitSize"
                  @click="setindex(index, item)"
                  v-show="i !== index"
                  >回复</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="lc">
          {{ item.comment }}
        </div>
        <div class="lc1" v-if="item.reply_comment.comment">
          {{ item.reply_comment.comment }}
        </div>
        <!-- <div v-show="i === index">
          <el-input
            :ref="'elinput' + index"
            type="textarea"
            v-model="item.replycomment"
            :placeholder="`回复  @${item.employee.name}：`"
            @blur="blur(item.replycomment)"
          ></el-input>
          <div class="lt mar">
            <el-button
              :disabled="!item.replycomment"
              type="primary"
              :size="subUnitSize"
              @click="sendcomment(item)"
              >提交</el-button
            >
          </div>
        </div> -->
      </div>
    </div>
    <div class="sendf">
      <el-input
        maxlength="500"
        ref="sendfinput"
        class="sendfinput"
        :size="subUnitSize"
        v-model="comment"
        clearable
        v-show="i === ''"
        placeholder="评论日志，限500字以内..."
      >
      </el-input>
      <el-input
        maxlength="500"
        ref="sendfinput1"
        class="sendfinput"
        :size="subUnitSize"
        v-model="comment"
        clearable
        v-show="i !== ''"
        placeholder="请输入回复内容...."
      >
        <div slot="prepend" v-show="i !== ''">
          回复 @{{ item.employee.name }}
        </div>
      </el-input>
      <div class="lt">
        <el-button
          v-show="i === ''"
          type="primary"
          :size="subUnitSize"
          @click="subcomment"
          :disabled="!comment"
          >发送</el-button
        >
        <el-button
          v-show="i !== ''"
          type="primary"
          :size="subUnitSize"
          @click="sendcomment(item)"
          :disabled="!comment"
          >发送</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Logcomment",
  props: {
    commentdata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      comment: "",
      i: "",
      userid: localStorage.getItem("userid"),
      item: {
        employee: {
          name: "",
        },
      },
    };
  },
  computed: {
    comments() {
      return this.commentdata.comments.map((item) => {
        return {
          ...item,
          replycomment: "",
        };
      });
    },
  },

  methods: {
    setindex(index, item) {
      this.item = item;
      this.i = index;
      this.$nextTick(() => {
        if (this.i !== "") {
          this.$refs.sendfinput1.focus();
        }
      });
    },
    subcomment() {
      this.$http
        .post("/admin/employeeLog/comment", {
          id: this.commentdata.id,
          comment: this.comment,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("评论成功");
            this.comment = "";
            this.$emit("logcomment");
          }
        });
    },
    blur(replycomment) {
      if (!replycomment) return (this.i = "");
    },
    setreplycomment(item) {
      // item.replycomment = "";
      this.i = "";
    },
    sendcomment(item) {
      this.$http
        .post("/admin/employeeLog/comment", {
          id: this.commentdata.id,
          comment: this.comment,
          reply_comment_id: item.id,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("评论成功");
            // item.replycomment = "";
            this.comment = "";
            this.i = "";
            this.$emit("logcomment");
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.logcomment {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
}
.lflex {
  display: flex;
  align-items: center;
  flex: 1;
  margin: 5px 0 0;
}
.jus {
  justify-content: space-between;
}
.img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 10px 0 0;
}
.lc {
  padding: 0 0 0 50px;
  color: #666666;
  font-size: 16px;
}
.lt {
  display: flex;
  justify-content: flex-end;
}
.mar {
  margin: 10px 0 0;
}
.comments {
  padding: 0 20px;
  flex: 1;
}
.sendf {
  height: 60px;
  background: #fff;
  border-top: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  position: sticky;
  bottom: 0;
  left: 0;
  padding: 0 20px;
  right: 0;
}
.sendfinput {
  flex: 1;
}
::v-deep .sendfinput .el-input-group__prepend {
  background-color: #fff;
}
.sl {
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  padding: 30px 0;
}
.time {
  color: #999999;
}
.lflex1 {
  flex: 1;
  justify-content: space-between;
  display: flex;
  align-items: center;
}
.tan {
  background: #0476fc;
  width: 40px;
  height: 40px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.ed {
  padding: 10px 0;
  border-bottom: 1px solid #e5e5e5;
}
.employees {
  display: flex;
  flex-wrap: wrap;
}
.items {
  text-align: center;
  margin: 10px 20px 0 0;
  position: relative;
}
.picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.tan {
  background: #0476fc;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.is_read {
  font-size: 12px;
  color: #21fc04;
}
.lc1 {
  margin: 5px 0 20px 50px;
  padding: 0 0 0 10px;
  height: 40px;
  color: #666666;
  background: #eeeeee;
  border-radius: 5px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.isRead {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>